import React from 'react';
import FaqItem from 'src/components/Faqs/SubComponents/FaqItem/FaqItem';
import './FaqsRepeater.scss';

interface FaqsRepeaterProps {
  faqs: any[];
  user: any;
  hideActions?: boolean;
  onEdit: (faq: any) => void;
  onDelete: (faq: any) => void;
  onImageClicked: (index: number, image: string) => void;
}

const FaqsRepeater = ({
  faqs,
  user,
  hideActions,
  onEdit,
  onDelete,
  onImageClicked,
}: FaqsRepeaterProps) => {
  const role: string = user.roles[0].role.name;
  const hideFaqActions: boolean =
    role === 'Home Owner' || role === 'Strata Manager' || role === 'Realtor';

  return (
    <div className="faqs-repeater">
      {faqs.map((faq: any, x: number) => (
        <FaqItem
          key={x}
          faq={faq}
          index={x}
          hideActions={hideActions ?? false}
          hideFaqActions={hideFaqActions}
          onEdit={onEdit}
          onDelete={onDelete}
          onImageClicked={onImageClicked}
        />
      ))}
    </div>
  );
};

export default FaqsRepeater;
